import { gqlType } from "@hifieng/common";
import { longDate } from "../../../helpers/formatDate";
import { MILLISECONDS_IN_SECONDS } from "../../../helpers/constants";
import {
  tmPigName,
  getPigTypeFromMetadata,
  formatPigTypeForDisplay
} from "../../../helpers/pigMetadata";

const formatCompletedRuns = (
  runs: Array<gqlType.PigRun>,
  timeOptions: {
    timezoneAbbr: string;
    utcOffset: string;
  }
) => {
  const start = (run: gqlType.PigRun) =>
    `${
      timeOptions
        ? longDate(run.startTime * MILLISECONDS_IN_SECONDS, timeOptions)
        : ""
    }\n${run.startLocation.latitude}, ${run.startLocation.longitude} `;

  const end = (run: gqlType.PigRun) =>
    run.endTime && run.endLocation
      ? `${
          timeOptions
            ? longDate(run.endTime * MILLISECONDS_IN_SECONDS, timeOptions)
            : timeOptions
        }\n${run.endLocation.latitude}, ${run.endLocation.longitude} `
      : "--";

  // const type = (run: gqlType.PigRun) =>
  //   run.type ? formatPigTypeForDisplay(run.type) : "--";

  return runs.map(run => {
    const rawPigType = getPigTypeFromMetadata(run.updates) || run.type;
    const pigType = rawPigType ? formatPigTypeForDisplay(rawPigType) : "--";
    const tmName = tmPigName(run, rawPigType || undefined);
    const pigName = tmName
      ? tmName
      : `${run.pipeline.name}${
          run.latest.pipelineName !== run.pipeline.name
            ? ` to ${run.latest.pipelineName}`
            : ``
        }`;
    return {
      id: run.id,
      data: [
        `${pigName} - Run ${run.runId}`,
        pigType,
        start(run),
        end(run),
        `${run.numberOfUpdates}`,
        `${run.numberOfCriticalEvents}`
      ],
      numAuditLogs: run.auditLogs.length,
      auditLogs: run.auditLogs
        .map(log => {
          return log.comment.message;
        })
        .join(", ")
    };
  });
};

export default formatCompletedRuns;
